<template>
    <header class="application-header header-container header-dashboard">
        <div class="logo">
            <icon name="astra-bookmark" />
            <span class="owner"><strong>ASTRA</strong>/</span><span class="application">Administration</span>
        </div>
        <div class="user" v-clickoutside="handleClose">
            <button type="button" @click="toggleMenu()">
                <div class="user-image">
                    <icon name="user" />
                </div>
                <div class="user-info">
                    <div class="user-info-name">{{ userInfo.name }}</div>
                    <div class="user-info-organization">{{ selectedOrganization.name }}</div>
                </div>
            </button>

            <div class="user-controls" :class="{ 'js-show': showMenu }">
                <ul>
                    <li v-if="driveEndpoint">
                        <a :href="driveEndpoint" target="_blank">Gå til Opgavestyring</a>
                    </li>
                    <li v-if="facilityEndpoint">
                        <a :href="facilityEndpoint" target="_blank">Gå til Anl&aelig;gsregister</a>
                    </li>
                    <li>
                        <button data-toggle="user-dropdown" @click="signOut()">
                            Log ud
                            <icon name="log-out" class="smaller-svg" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import clickoutside from './../../../mixins/shared/clickoutside.js'

export default {
    name: 'applicationHeader',
    directives: {
        clickoutside
    },
    data () {
        return {
            showMenu: false
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            selectedOrganization: 'getSelectedOrganization',
            driveEndpoint: 'getDriveEndpoint',
            facilityEndpoint: 'getFacilityEndpoint'
        })
    },
    methods: {
        ...mapActions({
            onSignOut: 'signOut'
        }),
        signOut () {
            this.onSignOut().then((response) => {
                let workLink = this.$router.resolve({ name: 'login' })
                window.location = workLink.href
            })
        },
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        handleClose () {
            if (this.showMenu) {
                this.toggleMenu()
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/application-header.scss';
</style>



// WEBPACK FOOTER //
// src/components/shared/header/application-header.vue